import React from 'react';
import ReactDOM from 'react-dom/client';
/*import './fonts/Finador-Light.ttf';
import './fonts/futura-light-bt.ttf';
import './fonts/Futura-Medium-01.ttf';
import './fonts/FutuBk.ttf';
*/
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
